import { render, staticRenderFns } from "./ConferenciaListGeral.vue?vue&type=template&id=0bbb94ea"
import script from "./ConferenciaListGeral.vue?vue&type=script&lang=js"
export * from "./ConferenciaListGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports